import Navbar from './Navbar';

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js